import { useQuery } from "@tanstack/react-query";

import { Calibrations } from "../../../api/calibrations";
import { CalibrationData } from "../../../api/types/calibration";
import { QueryKey } from "../../../consts/query-keys";
import { ApiError } from "../../../types/api-error";

export type UseCalibrationDataProps = {
  datasetId: number;
  cafsId: number;
  cafsType: "plant" | "input";
};

export function useCalibrationData({
  datasetId,
  cafsId,
  cafsType,
}: UseCalibrationDataProps) {
  const queryFn = () => {
    if (cafsType === "plant") {
      return Calibrations.getPlantCalibration({
        path: { datasetId, plantId: cafsId },
      });
    } else {
      return Calibrations.getInputCalibration({
        path: { datasetId, inputId: cafsId },
      });
    }
  };

  const {
    data: calibrationData,
    isPending,
    error,
  } = useQuery<CalibrationData, ApiError>({
    queryKey: [QueryKey.Calibration, datasetId, cafsId, cafsType],
    queryFn: queryFn,
    retry: false, // Don't retry on 404
    throwOnError: false, // Handle 404 gracefully
  });

  // Return null if 404 (calibration doesn't exist)
  const hasCalibration = error?.Status !== 404 && calibrationData !== undefined;

  return {
    calibrationData: hasCalibration ? calibrationData : null,
    isPending,
    hasCalibration,
  };
}
